import {Box, SvgIcon} from "@mui/material";
import React from "react";

export default function AmmunitionIcon(props) {
  return(
      <img src="/Icons/ammunition.svg" alt="ammunition" {...props}/>
  )
}